//TimePeriod.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Util from "../Util/Util";
import * as Util_MUI from "../Util/Util_MUI";

import { Icon, IconButton, TextField } from "@mui/material";

import React from "react";

let ss: SalesSearchSettings.iSS; //Settings.

export let fromDateYMD: string; // "yyyy-mm-dd" format for html component and query.
export let toDateYMD: string;   // "yyyy-mm-dd" format for html component and query.

let fromDate: string;    // "d/m/yyyy" format.
let toDate: string;      // "d/m/yyyy" format.

let saleTimePeriod: string;

//Clear time period.
export function clearTimePeriod() {
   fromDateYMD = "";
   toDateYMD = "";
   saleTimePeriod = "Custom";
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of TimePeriod Render");

   //Initialize only one time.
   if (typeof ss === "undefined") {
      ss = SalesSearchSettings.ss; //Get settings.

      //Initialize dropdown menus.
      saleTimePeriod = ss.saleDate_spans[7];

      //Initialize time period.
      const dateFromInit: Date = new Date();
      dateFromInit.setFullYear(dateFromInit.getFullYear() - 3);
      fromDate = dateFromInit.ToShortDate();
      fromDateYMD = Util.shortDateToYMD(fromDate);

      toDate = new Date().ToShortDate();
      toDateYMD = Util.shortDateToYMD(toDate);
   }

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {
   });

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Sale date time period changed.
   function timePeriodChanged(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
      saleTimePeriod = event.target.value;

      if (saleTimePeriod === "Custom") {
         return;
      }

      const i: number = Util.parseInteger(saleTimePeriod);
      const dateFrom: Date = new Date();

      if (saleTimePeriod.Contains("Month")) {
         dateFrom.setMonth(dateFrom.getMonth() - i);

      } else if (saleTimePeriod.Contains("Year")) {
         dateFrom.setFullYear(dateFrom.getFullYear() - i);
      }

      fromDate = dateFrom.ToShortDate();
      fromDateYMD = Util.shortDateToYMD(fromDate);

      toDate = new Date().ToShortDate();
      toDateYMD = Util.shortDateToYMD(toDate);

      SalesSearch.autoSearch();
      refresh();
   }

   function fromDateChanged(event: React.ChangeEvent<HTMLInputElement>) {
      const value: string = event.target.value;
      fromDateYMD = value;

      const date = new Date(fromDateYMD);
      fromDate = date.ToShortDate();

      saleTimePeriod = "Custom";
      refresh();
   }

   function toDateChanged(event: React.ChangeEvent<HTMLInputElement>) {
      const value: string = event.target.value;
      toDateYMD = value;

      const date = new Date(toDateYMD);
      toDate = date.ToShortDate();

      saleTimePeriod = "Custom";
      refresh();
   }

   function clearDateRange() {
      clearTimePeriod();
      SalesSearch.autoSearch();
      refresh();
   }

   //Set render values.
   let clearTimePeriodDisabled: boolean = false;
   if (fromDateYMD === "" && toDateYMD === "") {
      clearTimePeriodDisabled = true;
   }

   const styles: Default.iStyles = {
      clearButton: { border: '1px solid silver' },
   };

   return (
      <div className="app-flex-row-between">

         <TextField select style={{ width: 105 }}
            label="Time period"
            title="Filter search results by sale date range"
            inputProps={{ id: "sale-date" }}
            InputLabelProps={{ htmlFor: "sale-date" }}
            value={saleTimePeriod}
            onChange={timePeriodChanged}
         >
            {Util_MUI.buildSelectMenuItems(ss.saleDate_spans)}
         </TextField>

         <div className="app-flex-column-around">
            <TextField
               id="from-sale-date"
               label="From sale date"
               style={{ width: 175 }}
               type="date"
               margin="dense"
               InputLabelProps={{ shrink: true }}
               value={fromDateYMD}
               onChange={fromDateChanged}
            />

            <TextField
               id="to-sale-date"
               label="To sale date"
               style={{ width: 175 }}
               type="date"
               margin="dense"
               InputLabelProps={{ shrink: true }}
               value={toDateYMD}
               onChange={toDateChanged}
            />
         </div>

         <IconButton style={styles.clearButton} color="primary" size="small" onClick={clearDateRange} disabled={clearTimePeriodDisabled} title="Clear date range search filter" aria-label="Clear">
            <Icon fontSize="small">clear</Icon>
         </IconButton>
      </div>
   ); //end return.

} //end function.
